import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { LicenseResponse } from '../../api/clients/identity/LicensingClient'
import { FullscreenSpinner } from '../../components/feedback/circular'
import { SessionService } from '../../services/session'
import { onLicensedFor } from '../../services/session/LicensingService'
import { makeChildRoute } from '../../utils/CreateChildRoute'
import PackageListsRouter from '../PackageLists/PackageListsRouter'
import SidebarLayoutProvider from '../SidebarLayoutProvider'
import AdministrationRouter from './Administration'
import LicensingCheck from './Administration/Licensing/LicenseCheck'
import { UserProfileEdit } from './Administration/Users/UserPage/UserPage'
import OrganizationFrame from './OrganizationFrame'

const OrganizationRouter = () => {
	console.log('matched at organization router')

	const { path } = useRouteMatch()
	const sessionService = SessionService.getInstance()

	return (
		<OrganizationFrame>
			<SidebarLayoutProvider>
				<Switch>
					<Route path={makeChildRoute('_form-packages', path)}>
						<FormPackagesListRouter path={path} />
					</Route>
					<Route path={makeChildRoute('_administration', path)}>
						<AdministrationRouter />
					</Route>
					<Route
						path={[
							makeChildRoute('_users/:userId', path),
							makeChildRoute('_user/_home', path),
						]}
						render={(props) => (
							<Box width="100%" height="100%" sx={{ padding: '0px 24px' }}>
								<UserProfileEdit
									userId={
										// if it ends with home we want the current user's id,
										// otherwise we'll get the id from the route in the component
										props.match.path.endsWith('_home')
											? sessionService.userId
											: undefined
									}
								/>
							</Box>
						)}
					/>

					<Route path={makeChildRoute('/', path)}>
						<Redirect to={makeChildRoute('_user/_home', path)} />
					</Route>
				</Switch>
			</SidebarLayoutProvider>
		</OrganizationFrame>
	)
}

export default OrganizationRouter

type FormPackagesListRouterProps = {
	path: string
}

const FormPackagesListRouter = ({ path }: FormPackagesListRouterProps) => {
	const [isLicensed, setIsLicensed] = useState<boolean>()

	useEffect(() => onLicensedFor('Forms inMotion Forms', setIsLicensed), [])

	const licensingDemand = (v: LicenseResponse) => {
		const module = v.modules['Forms inMotion Forms']
		if (module === undefined) return false
		const startDate = new Date(module.startDate)
		const endDate = new Date(module.expirationDate)
		const currentDate = new Date()

		return startDate < currentDate && endDate > currentDate
	}

	if (isLicensed === undefined) return <FullscreenSpinner />
	if (!isLicensed) return <></>

	return (
		<LicensingCheck demandCheck={licensingDemand}>
			<PackageListsRouter />
		</LicensingCheck>
	)
}
